import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './styles.css'
import { App } from './App'
import { AuthProvider } from './auth'
import { ToastProvider } from './components/ui'
import { PwaBridge } from './components/PwaBridge'
import { listenToServiceWorker, registerServiceWorker } from './lib/push'
import { installErrorReporting } from './lib/errors'

// The console is an installable app (public/manifest.webmanifest) with a service worker for push (public/sw.js).
// The worker never caches scripts or API calls, so registering it in development does not get in the way of
// Vite's hot reload. Listen before React mounts so a "go to this page" message from a tapped notification
// that opened this window is not lost.
// Uncaught errors go to the error tracker when VITE_SENTRY_DSN is set (lib/errors.ts).
installErrorReporting()
listenToServiceWorker()
if (document.readyState === 'complete') void registerServiceWorker()
else window.addEventListener('load', () => { void registerServiceWorker() }, { once: true })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <PwaBridge />
          <App />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
)
